<template>
    <span class="ath-grade-badge f fa-c fj-c br-m"
        :class="[
            `el--s-${size}`,
            uiTextClass,
            grade ? `el--g-${grade.toLowerCase()}` : 'el--empty',
        ]">
        {{ grade || '—' }}
    </span>
</template>

<script>
/**
 * A composite score letter grade in a rounded square tinted for the grade
 */
export default {
    name: 'mead-grade-badge',
    props: {
        /**
         * Letter grade to display: A, B, C, D or F. Shows a dash when empty.
         */
        grade: {type: String, default: null},
        /**
         * Size of the badge. "s" for inline lists, "m" for score cards, "l" and "xl"
         * for featured scores.
         */
        size: {type: String, default: 'm', validator: value => ['s', 'm', 'l', 'xl'].includes(value)},
    },
    computed: {
        uiTextClass: function () {
            return {s: 'te-strong', m: 'te-fat-small', l: 'te-fat-light', xl: 'te-fat'}[this.size];
        },
    },
};
</script>
<style lang="scss">
.ath-grade-badge {
    flex-shrink: 0;

    &.el--s-s {
        width: 2.4rem;
        height: 2.4rem;
    }

    &.el--s-m {
        width: 4rem;
        height: 4rem;
    }

    &.el--s-l {
        width: 5.6rem;
        height: 5.6rem;
    }

    &.el--s-xl {
        width: 8rem;
        height: 8rem;
    }

    &.el--empty {
        background-color: var(--c-panel-border);
        color: var(--c-txt-light);
    }

    @each $grade in (a, b, c, d, f) {
        &.el--g-#{$grade} {
            background-color: var(--c-grade-#{$grade}-bg);
            color: var(--c-grade-#{$grade}-fg);
        }
    }
}
</style>
